export const environment = {
  production: false,
  appVersion: 'rc',
  beServiceUrl: 'https://be-cot-preprod.regione.abruzzo.it/api',
  ehrServerUrl: 'https://ehr-cot-preprod.regione.abruzzo.it/rest/v1/',
  keycloak: {
    url: 'https://keycloak-cot-preprod.regione.abruzzo.it',
    realm: 'cot',
    clientId: 'cot_dashboard',
  }
};
